/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateVersionResponse = {
  /**
   * Unique version identifier
   */
  id: string;
  /**
   * Parent prompt identifier
   */
  promptId: string;
  /**
   * Version number
   */
  version: number;
  /**
   * Object type
   */
  object: "prompt.version";
  /**
   * The prompt template text with {{variable}} placeholders
   */
  template: string;
  /**
   * Timestamp when this version was created
   */
  createdAt: Date;
};

/** @internal */
export const CreateVersionResponse$inboundSchema: z.ZodType<
  CreateVersionResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  prompt_id: z.string(),
  version: z.number().int(),
  object: z.literal("prompt.version"),
  template: z.string(),
  created_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
}).transform((v) => {
  return remap$(v, {
    "prompt_id": "promptId",
    "created_at": "createdAt",
  });
});
/** @internal */
export type CreateVersionResponse$Outbound = {
  id: string;
  prompt_id: string;
  version: number;
  object: "prompt.version";
  template: string;
  created_at: string;
};

/** @internal */
export const CreateVersionResponse$outboundSchema: z.ZodType<
  CreateVersionResponse$Outbound,
  z.ZodTypeDef,
  CreateVersionResponse
> = z.object({
  id: z.string(),
  promptId: z.string(),
  version: z.number().int(),
  object: z.literal("prompt.version"),
  template: z.string(),
  createdAt: z.date().transform(v => v.toISOString()),
}).transform((v) => {
  return remap$(v, {
    promptId: "prompt_id",
    createdAt: "created_at",
  });
});

export function createVersionResponseToJSON(
  createVersionResponse: CreateVersionResponse,
): string {
  return JSON.stringify(
    CreateVersionResponse$outboundSchema.parse(createVersionResponse),
  );
}
export function createVersionResponseFromJSON(
  jsonString: string,
): SafeParseResult<CreateVersionResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateVersionResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateVersionResponse' from JSON`,
  );
}
